var _path, _ellipse, _ellipse2, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPulseLine3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 126,
    viewBox: "0 0 383 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-233.5 2C-113.5 2 -105 177 85.5 82C121 57.3333 170.5 25.5 382.5 42.5",
    stroke: "#F4F5FA",
    strokeWidth: 4,
    strokeDasharray: "16 16"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 86.5,
    cy: 81.3639,
    rx: 44.5,
    ry: 44.3639,
    fill: "url(#paint0_radial_1195_115850)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 86.5003,
    cy: 81.3644,
    rx: 26.7,
    ry: 26.6183,
    fill: "url(#paint1_radial_1195_115850)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 81.5725,
    r: 7,
    fill: "#3083DC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1195_115850",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.5 81.3639) rotate(90) scale(67.5541 67.7614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3083DC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3083DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1195_115850",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.5003 81.3644) rotate(90) scale(40.5325 40.6568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3083DC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3083DC"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPulseLine3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pulse-line-3.098bf2de3d655cba490654b4435923b6.svg";